import * as React from "react";
import Box from "@mui/material/Box";
import { PieChart } from "@mui/x-charts/PieChart";
import { useSelector } from "react-redux";

export default function PieGraphicSpecialist() {
  const {
    totalSpecialistNutricionist,
    totalSpecialistPhysiotherapy,
    totalSpecialistPsychologist,
    totalSpecialistCoach,
  } = useSelector((state) => state.usersReducer);
  //   console.log(
  //     "totalSpecialistNutricionist",
  //     totalSpecialistNutricionist.length
  //   );
  //   console.log(
  //     "totalSpecialistPhysiotherapy",
  //     totalSpecialistPhysiotherapy.length
  //   );
  //   console.log(
  //     "totalSpecialistPsychologist",
  //     totalSpecialistPsychologist.length
  //   );
  //   console.log("totalSpecialistCoach", totalSpecialistCoach.length);

  const colors = ["#2E5BFF", "#00A86B", "#5F6B7C", "#FF7D33"];
  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <PieChart
        height={350}
        width={350}
        margin={{ top: 20, bottom: 120, left: 20, right: 20 }}
        slotProps={{
          legend: {
            direction: "row",
            position: { vertical: "bottom", horizontal: "middle" },
            padding: { top: 20, bottom: 20 },
            itemMarkWidth: 10,
            itemMarkHeight: 10,
            labelStyle: { fontSize: 18 },
            markGap: 5,
            itemGap: 10,
          },
        }}
        series={[
          {
            data: [
              {
                id: 0,
                value: totalSpecialistNutricionist.length ?? 0,
                label: "Nutriólogos",
                color: colors[0],
              },
              {
                id: 1,
                value: totalSpecialistPhysiotherapy.length ?? 0,
                label: "Fisioterapeutas",
                color: colors[1],
              },
              {
                id: 2,
                value: totalSpecialistPsychologist.length ?? 0,
                label: "Psicólogos",
                color: colors[2],
              },
              {
                id: 3,
                value: totalSpecialistCoach.length ?? 0,
                label: "Entrenadores",
                color: colors[3],
              },
            ],
            innerRadius: 50,
            arcLabel: (params) => params.label ?? "",
            arcLabelMinAngle: 20,
            outerRadius: 100,
          },
        ]}
      />
    </Box>
  );
}
